// Nice to keep as constants, as they are often used as locators in E2E tests, and as such only need to be updated in one place if they change.
export const PAGE_TITLES = {
  overview: 'Oversikt',
  account: 'Din konto',
}
